// Checklist de prontidao da curadoria. Nada sai com a chave desligada, e a
// chave so liga com o checklist completo (o banco revalida no save).
const CREDENTIAL_HINTS = {
    missing: "Cadastre a credencial da loja em Credenciais.",
    incomplete: "Complete os campos da credencial em Credenciais.",
    invalid: "A credencial foi recusada pela loja. Revise em Credenciais.",
    valid: null,
};
export function buildReadiness(input) {
    const { pace } = input;
    return [
        {
            key: "credential",
            ok: input.credential === "valid",
            label: "Credencial da loja",
            hint: CREDENTIAL_HINTS[input.credential],
        },
        {
            key: "categories",
            ok: input.categoryCount > 0,
            label: "Categorias escolhidas",
            hint: input.categoryCount > 0 ? null : "Escolha pelo menos uma categoria.",
        },
        {
            key: "destinations",
            ok: input.destinationCount > 0,
            label: "Destinos para receber",
            hint: input.destinationCount > 0 ? null : "Marque pelo menos um grupo ou canal.",
        },
        {
            key: "pace",
            ok: pace.isSustainable && pace.productsPerDay > 0,
            label: "Ritmo sustentável",
            hint: paceHint(input),
        },
    ];
}
function paceHint(input) {
    if (input.pace.productsPerDay === 0) {
        return "Com a janela de envio atual nenhum ciclo cabe no dia. Aumente a janela ou reduza o intervalo.";
    }
    if (input.pace.isSustainable) {
        return null;
    }
    const missing = input.pace.minCategories - input.categoryCount;
    return `Escolha mais ${missing} ${missing === 1 ? "categoria" : "categorias"} ou reduza o ritmo.`;
}
export function isReady(items) {
    return items.every((item) => item.ok);
}
//# sourceMappingURL=readiness.js.map